import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'stairs-up', 'StairsUp', [["path",{"d":"M22 6h-5v5h-5v5h-5v5h-5"}],["path",{"d":"M6 10v-7"}],["path",{"d":"M3 6l3 -3l3 3"}]]);